<template>
	<div>
		<div class="headBox">
			<div class="head">
				<div class="headBack">
					<img src="@/images/headBack.png" />
				</div>
				<div class="headCont">
					<img :src="baseurl + logoinfo" class="headLogo" @click="toName('index')" v-if="logoinfo" />
					<img src="@/images/logo.png" class="headLogo" @click="toName('index')" v-else/>
					<div class="headMenu">
						<div class="headMenuItem" :class="{'active':tabindex==1}" @click.stop="toName('index')">
							<span>首页</span>
							<img src="@/images/headMenuItem.png" />
						</div>
						<div class="headMenuItem" :class="{'active':tabindex==2}" @click.stop="toName('fictitious')">
							<span>虚拟仿真</span>
							<img src="@/images/headMenuItem.png" />
						</div>
						<div class="headMenuItem" :class="{'active':tabindex==3}" @click.stop="toName('courses')">
							<span>在线课程</span>
							<img src="@/images/headMenuItem.png" />
						</div>
						<div class="headMenuItem" :class="{'active':tabindex==4}" @click.stop="toName('examinelist')">
							<span>在线考试</span>
							<img src="@/images/headMenuItem.png" />
						</div>
						<div class="headMenuItem" :class="{'active':tabindex==5}" @click.stop="toName('news')">
							<span>新闻资讯</span>
							<img src="@/images/headMenuItem.png" />
						</div>
					</div>
					<div class="headUser">
						<div class="headUserMenu" v-if='!userinfo.name' @click="relogin">
							请登录
						</div>
						<div class="headUserLogin" v-if='userinfo.name'>
							<div class="headMessage" @click.stop='openList(2)'>
								<el-badge :value="mymessage.length || 0" :hidden="mymessage.length<=0">
									<i class="el-icon-chat-dot-round"></i>
								</el-badge>
							</div>
							<div class="headUserIcon" @click.stop='openList(1)'>
								<img :src="baseurl + userinfo.iconurl" v-if="userinfo.iconurl" />
								<img src="@/images/1.png" v-else/>
							</div>
							<div class="headUserInfo text-ellipsis" @click.stop='openList(1)'>
								{{userinfo.name}}
							</div>
							<el-collapse-transition>
								<div class="headUserMore shadow" @click.stop v-show="showmenu">
									<div class="headUserMoreItem" @click="toName('center')">个人中心</div>
									<div class="headUserMoreItem" @click="showpass = true">修改密码</div>
									<div class="headUserMoreItem" @click="tologout()">退出登录</div>
								</div>
							</el-collapse-transition>
							<el-collapse-transition>
								<div class="headMessageMore darkScorll shadow" @click.stop v-show="showmess">
									<emptymain :emptytext="'暂无消息'" :emptylist='mymessage'></emptymain>
									<div class="headMessageItem" v-for="(item,index) in mymessage" @click.stop='toReadMessage(item)'>
										<div v-if="item.sign == 'moocTask'">
											课程作业：<span class="primaryColor">{{item.moocName}}</span>课程下有未完成的作业<span class="primaryColor">{{item.moocTaskName}}</span>,请点击查看
										</div>
										<div v-if="item.sign == 'vrTask'">
											实验作业：<span class="primaryColor">{{item.vrName}}</span>实验下有未完成的作业<span class="primaryColor">{{item.vrTaskName}}</span>,请点击查看
										</div>
										<div v-if="item.sign == 'notice'">
											校内公告：<span class="primaryColor">{{item.noticeTitle}}</span>
										</div>
										<div v-if="item.sign == 'exam'">
											在线考试：<span class="primaryColor">在线考核</span>中有考试<span class="primaryColor">{{item.examName}}</span>未参考,请点击查看
										</div>
										<div v-if="item.sign == 'vrExam'">
											实验考试：<span class="primaryColor">在线考核</span>中有实验考试<span class="primaryColor">{{item.vrExamName}}</span>未参考,请点击查看
										</div>
									</div>
								</div>
							</el-collapse-transition>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--登录页面-->
		<div class="form" v-show='loginback'>
			<div class="login_back">
				<img src="@/images/login_banner.png" class="login_banner" />
				<img src="@/images/login_img.png" class="login_img" />
				<i class="login_close el-icon-close" @click="cancelBack"></i>
				<div class="login_formbox">
					<div class="login_title">
						<img src="@/images/login_title.png" /> 登录后
						<span>立即学习</span>
					</div>
					<el-form ref="loginForm" :model="user" :rules="rules" class="loginForm clearfix">
						<el-form-item prop="username" class="elform login_form">
							<el-input prefix-icon="el-icon-user-solid" v-model="user.username" placeholder="请输入用户名/学号" class="input login_input"></el-input>
						</el-form-item>
						<el-form-item prop="password" class="elform login_form">
							<el-input prefix-icon="el-icon-lock" type="password" v-model="user.password" placeholder="请输入密码" class="input login_input" @keyup.enter.native="submitForm()"></el-input>
						</el-form-item>
						<el-button type="primary" class="loginButton" @click="submitForm()">登录</el-button>
					</el-form>
				</div>
			</div>
		</div>
		<el-dialog title="修改密码" class="open_dialogInfo" :visible.sync="showpass" :append-to-body='true' width="450px" :close-on-click-modal='false' :close-on-press-escape='false' :show-close='false'>
			<div class="center_edit">
				<el-form :model="passForm" :rules="rules" ref="passForm" label-width="100px" class="center_editForm">
					<el-form-item label="旧密码" prop="oldpass" class="pas_pass">
						<el-input type="password" v-model="passForm.oldpass" placeholder="请输入旧密码" autocomplete="off" clearable style='width: 300px;'></el-input>
					</el-form-item>
					<el-form-item label="新密码" prop="pass" class="pas_pass">
						<el-input type="password" v-model="passForm.pass" placeholder="请输入新密码" autocomplete="off" clearable style='width: 300px;'></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="checkPass" class="pas_pass">
						<el-input type="password" v-model="passForm.checkPass" placeholder="请再次输入新密码" autocomplete="off" clearable style='width: 300px;'></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="center_btns">
				<el-button type='info' @click="resetForm()">取消</el-button>
				<el-button type='primary' @click="submitPassForm()">修改</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { getStorageToken, setStorageToken, removeStorageToken } from '@/utils/auth'
	import { login, getInfo, userMajorLogo, updateUserPass, myMessageNotice, messageRead } from "@/api/user"
	import { mapGetters } from "vuex"
	export default {
		name: 'headmain',
		data() {
			var validatePass0 = (rule, value, cadd_backimg) => {
				if(value === '') {
					cadd_backimg(new Error('请输入旧密码'));
				} else {
					cadd_backimg();
				}
			};
			var validatePass = (rule, value, cadd_backimg) => {
				if(value === '') {
					cadd_backimg(new Error('请输入新密码'));
				} else {
					if(this.passForm.checkPass !== '') {
						this.$refs.passForm.validateField('checkPass');
					}
					cadd_backimg();
				}
			};
			var validatePass2 = (rule, value, cadd_backimg) => {
				if(value === '') {
					cadd_backimg(new Error('请再次输入密码'));
				} else if(value !== this.passForm.pass) {
					cadd_backimg(new Error('两次输入密码不一致!'));
				} else {
					cadd_backimg();
				}
			};
			return {
				userinfo: {},
				mymessage: [],
				logoinfo: "",
				loginback: false,
				showmenu: false,
				showmess: false,
				showpass: false,
				tabindex: 0,
				user: {
					username: "",
					password: ""
				},
				passForm: {
					oldpass: '',
					pass: '',
					checkPass: '',
				},
				rules: {
					username: [{
						required: true,
						message: "请输入用户名",
						trigger: "blur"
					}],
					password: [{
						required: true,
						message: "请输入密码",
						trigger: "blur"
					}],
					oldpass: [{
						required: true,
						message: "请输入旧密码",
						trigger: "blur"
					}, {
						validator: validatePass0,
						trigger: 'blur'
					}],
					pass: [{
						required: true,
						message: "请输入新密码",
						trigger: "blur"
					}, {
						validator: validatePass,
						trigger: 'blur'
					}],
					checkPass: [{
						required: true,
						message: "请确认密码",
						trigger: "blur"
					}, {
						validator: validatePass2,
						trigger: 'blur'
					}],
				},
			}
		},
		computed: {
			...mapGetters([
				"loging",
				"newmessage"
			])
		},
		created() {
			this.tabindex = this.$route.meta.tabindex || 0;
			this.getLogo();
		},
		watch: {
			$route(val) {
				this.showmenu = false;
				this.showmess = false;
				if(val) {
					this.tabindex = this.$route.meta.tabindex || 0;
				}
			},
			loging(val) {
				if(val) {
					this.relogin()
				}
			},
			newmessage(val) {
				this.getinfo()
			},
		},
		mounted() {
			this.getinfo();
			this.tiggermenu();
		},
		methods: {
			openList(type) {
				if(type == '1') {
					this.showmess = false;
					this.showmenu = !this.showmenu;
				}
				if(type == '2') {
					this.showmenu = false;
					this.showmess = !this.showmess;
				}
			},
			toReadMessage(item) {
				this.showmenu = false;
				this.showmess = false;
				this.getmyMessage();
				if(item.sign == 'moocTask') {
					this.toCourseindex(item.vrCourseId)
				}
				if(item.sign == 'vrTask') {
					this.getLabInfo(item.vrCourseId)
				}
				if(item.sign == 'notice') {
					this.toDetails(item.signId)
				}
				if(item.sign == 'exam') {
					this.toExamList('first')
				}
				if(item.sign == 'vrExam') {
					this.toExamList('second')
				}
			},
			toCourseindex(courseId) {
				this.$router.push({
					name: 'redirect',
					query: {
						name: 'coursedetail',
						query: JSON.stringify({
							courseId: courseId,
							toTab: 'task'
						})
					}
				})
			},
			getLabInfo(vrDetailId) {
				this.$router.push({
					name: 'redirect',
					query: {
						name: 'center',
						query: JSON.stringify({
							navTabId: 'lab',
							navTabChildrenId: 'labwork',
							navTabChildrenPid: 'lab',
						})
					}
				})
			},
			toDetails(id) {
				this.$router.push({
					name: 'redirect',
					query: {
						name: 'newsdetail',
						query: JSON.stringify({
							id: id
						})
					}
				})
			},
			toExamList(activeName) {
				this.$router.push({
					name: 'redirect',
					query: {
						name: 'examinelist',
						query: JSON.stringify({
							activeName
						})
					}
				})
			},
			tiggermenu() {
				var that = this;
				$('#app').on('click', function() {
					that.showmenu = false;
					that.showmess = false;
				})
			},
			toName(name) {
				var token = getStorageToken();
				if(token) {
					if(this.$route.name != name) {
						this.$router.push({
							name: name
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			submitPassForm() {
				this.$refs.passForm.validate((valid) => {
					if(valid) {
						var data = {
							oldpassword: this.passForm.oldpass,
							password: this.passForm.pass,
						}
						updateUserPass(data).then(res => {
							if(res.code == 'OK') {
								this.$alert('修改成功，请重新登陆！', '提示', {
									confirmButtonText: '确定',
									type: 'warning'
								}).then(() => {
									removeStorageToken();
									location.reload()
								}).catch(() => {
									removeStorageToken();
									location.reload()
								})
							} else {
								this.$message({
									type: "error",
									message: res.msg
								})
							}
						})
					}
				});
			},
			resetForm() {
				this.$refs.passForm.resetFields();
				this.showpass = false;
			},
			relogin() {
				this.showmenu = false;
				this.showmess = false;
				removeStorageToken()
				this.loginback = true;
			},
			tologout() {
				this.showmenu = false;
				this.showmess = false;
				removeStorageToken();
				window.localStorage.clear();
				location.reload()
			},
			cancelBack() {
				this.loginback = false;
				this.$store.dispatch('user/openLogin', {
					loging: false
				})
			},
			getmyMessage() {
				myMessageNotice({
					majorId: this.majorIdForAll
				}).then(res => {
					if(res.code == 'OK') {
						this.mymessage = res.data || [];
					}
				})
			},
			getLogo() {
				userMajorLogo({
					majorId: this.majorIdForAll
				}).then(res => {
					if(res.code == 'OK' && res.data) {
						this.logoinfo = res.data.url
					}
				})
			},
			getinfo() {
				var token = getStorageToken();
				if(token) {
					this.getmyMessage()
					getInfo().then(res => {
						if(res.code == 'OK') {
							this.userinfo = res.data;
							window.localStorage.setItem('userId', res.data.userId);
							window.localStorage.setItem('name', res.data.name);
						}
					})
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			submitForm() {
				this.$refs.loginForm.validate(valid => {
					if(valid) {
						login({
							username: this.user.username,
							password: this.user.password,
							effective: this.effective,
						}).then(res => {
							if(res.code == 'OK') {
								setStorageToken(res.data);
								this.$store.dispatch('user/openLogin', {
									loging: false
								});
								this.loginback = false;
								location.reload()
							} else {
								this.$message({
									message: res.msg,
									type: 'error'
								})
							}
						});
					}
				})
			},
		},
	}
</script>